import { AuthenticationClient } from '../features/authentication/slice/authenticationSlice'
import { useAppDispatch } from '../app/typedReduxHooks'

export const useLogout = () => {
  const dispatch = useAppDispatch()
  return async () => {
    const clientId = localStorage.getItem('client_id')

    await dispatch(AuthenticationClient.Logout())

    if (clientId) {
      const cognitoAuthUri = process.env.REACT_APP_COGNITO_AUTH_URI
      const logoutRedirectUri = process.env.REACT_APP_COGNITO_LOGOUT_REDIRECT_URI
      if (!cognitoAuthUri || !logoutRedirectUri) {
        window.location.href = '/'
        return
      }
      const logoutUrl = new URL('/logout', cognitoAuthUri)
      logoutUrl.searchParams.set('client_id', clientId)
      logoutUrl.searchParams.set('logout_uri', logoutRedirectUri)
      window.location.href = logoutUrl.toString()
    }
  }
}
